import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"minus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.5 8h9s.5 0 .5.5-.5.5-.5.5h-9S3 9 3 8.5s.5-.5.5-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol